export default __webpack_public_path__ + "static/background-standard-fcb870605fc221dbdc4d9680b3acefd7.mp4";